/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import { Block, Input } from '@atoms';

import s from './styles.module.less';

const ListItem = ({ vocabulary, form, field }) => {
  const [inputValue, setInputValue] = React.useState(vocabulary.value);

  const onChange = (event, key) => {
    const fields = form.getFieldsValue();
    const { vocabularies } = fields;
    Object.assign(vocabularies[key], { value: event.target.value, isUpDated: 'true' });

    form.setFieldsValue({ vocabularies });
    setInputValue(event.target.value);
  };

  return (
    <Block spaced className={clsx(s.block, s.blockLine)}>
      <div className={clsx(s.blockElement, s.breakWord)}>{vocabulary.key}</div>
      <div className={clsx(s.blockElement, s.blockSecondElement)}>
        <Input value={inputValue} onChange={(e) => onChange(e, field.key)} className={clsx(s.input)} allowClear />
      </div>
    </Block>
  );
};

export default ListItem;
